import type { CastMember } from '@/types/educate';

interface CastPanelProps {
  setting?: string;
  cast?: CastMember[];
  columns?: 1 | 2;
}

export function CastPanel({ setting, cast, columns = 2 }: CastPanelProps) {
  const hasCast = Array.isArray(cast) && cast.length > 0;
  if (!setting && !hasCast) return null;

  return (
    <div>
      {setting && (
        <p className="flex items-start gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-amber-600">
          <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400" />
          {setting}
        </p>
      )}

      {hasCast && (
        <div className={`mt-3 grid gap-2 ${columns === 2 ? 'sm:grid-cols-2' : ''}`}>
          {cast!.map((member) => (
            <CastCard key={member.name} member={member} />
          ))}
        </div>
      )}
    </div>
  );
}

function CastCard({ member }: { member: CastMember }) {
  const isYou = member.name.trim().toLowerCase() === 'you';

  return (
    <div className="flex items-center gap-3 rounded-lg bg-slate-50 px-3 py-2">
      <span
        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[11px] font-bold uppercase ${
          isYou ? 'bg-brand-600 text-white' : 'bg-brand-100 text-brand-700'
        }`}
      >
        {isYou ? 'You' : member.name.charAt(0)}
      </span>
      <div className="min-w-0">
        <p className="text-sm font-bold text-slate-800">{member.name}</p>
        <p className="truncate text-xs text-slate-500">{member.role}</p>
      </div>
    </div>
  );
}
